/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useAncestorPath } from '@squiz/dxp-console-support';
import { Breadcrumbs, BreadcrumbsProps } from '@squiz/sds';
import { DxpScreen } from 'apps/console-core/src/Components/DxpScreen/DxpScreen';
import { useCapabilityBreadcrumbs } from 'apps/console-core/src/Hooks/UseCapabilityBreadcrumbs/UseCapabilityBreadcrumbs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MONITORING_DATA_IDS } from '../../Constants/DataIDs.constants';
import { MONITORING_STRINGS } from '../../Constants/Strings.constants';
import { ExperienceMonitoringPagePreviewContent } from './elements/ExperienceMonitoringPagePreviewContent/ExperienceMonitoringPagePreviewContent';

export const ExperienceMonitoringPagePreview = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    experienceMonitoring: t(MONITORING_STRINGS.experienceMonitoring),
    pagePreview: t(MONITORING_STRINGS.pagePreview),
  };
  const encodedURL = window.location.pathname.split('/').pop() as string;
  const capabilityBreadcrumbs = useCapabilityBreadcrumbs();
  const parentPath = useAncestorPath();
  const hostname = atob(encodedURL);

  const breadcrumbProps: BreadcrumbsProps = {
    currentPageName: hostname,
    links: [...capabilityBreadcrumbs, { name: labels.experienceMonitoring, url: parentPath }],
  };
  const breadcrumbs = <Breadcrumbs {...breadcrumbProps} data-id={MONITORING_DATA_IDS.breadcrumbs} />;

  const screenContent = (
    <>
      <ExperienceMonitoringPagePreviewContent host={hostname} />
    </>
  );

  return (
    <DxpScreen
      breadcrumbs={breadcrumbs}
      classes="monitoring-page-preview truncate-heading"
      heading={hostname}
      showSeparator
      title={`${labels.pagePreview}`}
    >
      {screenContent}
    </DxpScreen>
  );
};
